export const LEAD_PLACES_REDUCED = 'LEAD_PLACES_REDUCED';

const leadPlacesReduced = lead => (
  (dispatch) => {
    dispatch({
      type: LEAD_PLACES_REDUCED,
      lead,
    });
  }
);

export default leadPlacesReduced;
